<script>
import StarRating from "@/components/reviews/StarRating.vue";

export default {
  name: 'RatingNote',
  components: {StarRating},
  props: {
    note: {
      type: Number,
      required: true
    },
    numberReviews: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div v-if="note > 1" class="flex items-center gap-2 mt-2 sm:mt-0">
    <star-rating :note="Math.round(note)" />
    <p class="text-sm font-medium leading-none text-gray-500 dark:text-gray-400">
      ({{ note }})
    </p>
    <a href="#avis" class="text-sm font-medium leading-none text-gray-900 underline hover:no-underline dark:text-white">
      {{ numberReviews }} avis
    </a>
  </div>
  <div v-else>
    Aucun avis
  </div>
</template>
